<template>
    <HighChart
        :options="chartOptions"
    />
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import HighChart from '@agyletime/vue-3-common/src/components/Chart/HighChart.vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';

import { SeriesData } from '../interactionSummary/getData';

exportingInit(Highcharts);

interface IProps {
  categories: string[];
  series: SeriesData[];
}
const props = defineProps<IProps>();
const chartOptions = computed(() => ({
    credits: { enabled: false },
    title: {
        text: 'Count of Workload Interactions',
        align: 'left',
        style: {
            fontSize: '21px',
            fontWeight: 'bold',
            fontFamily: 'Realist'
        },
        margin: 24
    },
    yAxis: {
        title: {
            useHTML: true,
            text: '    ',
            margin: 16
        }
    },
    xAxis: { categories: props.categories },
    plotOptions: { series: { label: { connectorAllowed: false } } },
    series: props.series,
    responsive: {
        rules: [
            {
                condition: { maxWidth: 500 },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }
        ]
    }
}));
</script>

<style scoped lang="scss" src="./style.scss"></style>
